import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import EnglishJsonFile from './locale/en.json';
import SwahiliJsonFile from './locale/swa.json';
import legalContent from './locale/legalContent';

function buildTranslation(baseTranslation, legalTranslation) {
  return {
    ...baseTranslation,
    legal: {
      ...baseTranslation.legal,
      terms: {
        ...baseTranslation.legal.terms,
        ...legalTranslation.terms,
      },
      privacy: {
        ...baseTranslation.legal.privacy,
        ...legalTranslation.privacy,
      },
    },
  };
}

const resources = {
  English: { translation: buildTranslation(EnglishJsonFile, legalContent.English) },
  Swahili: { translation: buildTranslation(SwahiliJsonFile, legalContent.Swahili) },
};

i18n.use(initReactI18next).use(LanguageDetector).init({
  fallbackLng: 'English',
  resources,
});

export default i18n;
